import { Flex, FlexProps, Heading, Layout, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface SectionalBannerProps extends FlexProps<'div'> {
  headerIcon: ReactNode;
  title: string;
  description: string;
}

export default function SectionalBanner({
  headerIcon,
  title,
  description,
  ...layout
}: SectionalBannerProps) {
  return (
    <Layout
      {...layout}
      alignItems="center"
      borderRadius="4px"
      borderStyle="solid"
      borderWidth="1px"
      justifyContent="flex-start"
      px={[7, null, 9]}
      py={[7, null, 8]}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        minHeight="48px"
        minWidth="48px"
        overflow="hidden"
      >
        {headerIcon}
      </Flex>
      <Flex flexDirection="column" ml={4}>
        <Heading fontSize="xl" fontWeight="bold" mb={1}>
          {title}
        </Heading>
        <Text color="textNeutralLight" fontSize="md">
          {description}
        </Text>
      </Flex>
    </Layout>
  );
}
